

export function ebaySearchString(searchTerm: string) {
  return `https://www.ebay.co.uk/sch/i.html?_nkw=${searchTerm}&_sacat=0&_from=R40&rt=nc&LH_ItemCondition=4&LH_Sold=1&LH_Complete=1`
} 
